import PrimaryButton from "components/Buttons/PrimaryButton";
import React, { memo, useCallback, useState, useContext, useRef } from "react";
import { UserApi } from "utils/api";
import { useNavigate } from "react-router-dom";
import { userContext } from "contextProviders/userContext";
import TextArea from "components/FormElements/TextArea";
import { api_key, mall_id, LetterApi } from "utils/api";
import imgLetter from "img/letter-bg.png";

const LetterForm = memo(() => {
  const navigate = useNavigate();
  const [error, setError] = useState(null);
  const [dataSending, setDataSending] = useState(false);
  const [sended, setSended] = useState(false);
  const { user, setUser } = useContext(userContext);
  const fileInputRef = useRef();
  const [letter, setLetter] = useState("Дорогой Дед Мороз!\r\n");
  const [image, setImage] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);

  const handleImageSelect = useCallback((e) => {
    let reader = new FileReader();
    let file = e.target.files[0];
    reader.onloadend = () => {
      setImage(file);
      setImagePreview(reader.result);
      fileInputRef.current.value = null;
    };
    reader.readAsDataURL(file);
  }, []);

  const handleDowndload = useCallback(() => {
    setError(null);
  }, [setError]);

  const handleSubmit = useCallback(() => {
    setDataSending(true);

    const formData = new FormData();

    formData.append("api_key", api_key);
    formData.append("mall_id", mall_id);
    formData.append("letter", letter);
    formData.append("user_id", user.user_id);
    formData.append("auth_key", user.auth_key);
    formData.append("childName", user.childName);
    formData.append("childSurname", user.childSurname);
    formData.append("childAge", user.childAge);

    if (image) formData.append("image", image);

    LetterApi.sendMessage(formData)
      .then(() => {
        setImage(null);
        setImagePreview(null);
        setUser(null);
        navigate("/sent");
      })
      .catch((e) => {
        if (e.response && [400, 401].indexOf(e.response.status) !== -1) {
          setError(e.response.data);
        } else {
          setError({ error: "Ошибка связи с сервером", type: "tech" });
        }
      })
      .finally(() => setDataSending(false));
  }, [letter, user, setUser, image, navigate]);

  return (
    <React.Fragment>
      <div class="letter">
        {error && error.type !== "change" && (
          <p className="letter__title">{error.error}</p>
        )}

        <div className="letter-wrapper">
          <img src={imgLetter} alt="Письмо Деду Морозу" />
        </div>

        <div class="bottom">
          <TextArea
            label={"загрузить рисунок"}
            value={letter}
            setValue={setLetter}
          />
          <label className="input-file-label" htmlFor="input-file">
            загрузить рисунок
            <input
              id="input-file"
              ref={fileInputRef}
              className={"letter__input-file"}
              type="file"
              accept="image/*"
              onChange={handleImageSelect}
            />
            {imagePreview && (
              <img
                className="preview"
                src={imagePreview}
                alt="Превью картинки"
              />
            )}
          </label>
          <PrimaryButton
            text={dataSending ? "Подождите..." : "Отправить письмо"}
            className={"letter__btn"}
            disabled={dataSending}
            callback={handleSubmit}
          />
        </div>
      </div>

      {error && error.type === "change" && (
        <div className="form letter-modal">
          <div className="wrapper  wrapper--red">
            <p className="form__txt">
              Для отправки письма Деду&nbsp;Морозу, пожалуйста, обменяйте баллы
              на&nbsp;комплимент «Почта&nbsp;Деда&nbsp;Мороза» в&nbsp;мобильном
              приложении Каширская Плаза
            </p>
            <a
              onClick={handleDowndload}
              target="_blank"
              className="form__btn"
              href="https://jetcrm.ru/kashirka/kashirka.php"
            >
              перейти в приложение
            </a>
            <PrimaryButton
              callback={handleDowndload}
              className={"button-like-link"}
              text={"Обменял"}
            />
          </div>
        </div>
      )}
    </React.Fragment>
  );
});

export default LetterForm;
